import { Button, Card, Col, Descriptions, Row, Statistic } from 'antd';
import React from 'react';
import { QrcodeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Text from 'antd/es/typography/Text';
import { AFWallet } from '../../domain/report-provider/agentSourceWalletProvider';
import { popOutQRCode } from '../../../components/qrCode';

const CopyToClipboard = require('react-copy-to-clipboard');

export default function AFWalletInfo(props: { wallet: AFWallet }) {
  const { t } = useTranslation();
  return (
    <>
      <Card>
        <Descriptions column={1}>
          <Descriptions.Item label={t('payment.channel')}>
            {props.wallet.channel}
          </Descriptions.Item>
          <Descriptions.Item label={t('payment.token')}>
            {props.wallet.token}
          </Descriptions.Item>
          <Descriptions.Item label={t('payment.wallet_address')}>
            <QrcodeOutlined
              title={t('payment.wallet_address')}
              onClick={() =>
                popOutQRCode({ address: props.wallet.walletAddress })
              }
            />
            <Text style={{ margin: '0.1rem' }}>
              {props.wallet.walletAddress}
            </Text>
            <CopyToClipboard text={props.wallet.walletAddress}>
              <Button>{t('common.copy')}</Button>
            </CopyToClipboard>
          </Descriptions.Item>
        </Descriptions>
        <Row gutter={2}>
          <Col span={6}>
            <Statistic
              title={t('payment.balance')}
              value={props.wallet.balance}
              precision={6}
            />
          </Col>
          {/*<Col span={6}>*/}
          {/*  <Statistic*/}
          {/*    title={t('payment.txnBalance')}*/}
          {/*    value={props.wallet.txnBalance}*/}
          {/*    precision={6}*/}
          {/*  />*/}
          {/*</Col>*/}
          <Col span={6}>
            <Statistic
              title={t('payment.txnBalance')}
              value={props.wallet.txnBalance}
              precision={6}
            />
          </Col>
        </Row>
      </Card>
    </>
  );
}
